import React, { memo } from 'react';
import {
	Route,
	Switch,
	useRouteMatch
} from 'react-router-dom';

import { log } from '../../../../services/utils';

import { Provider as AdminProvider } from '../../../../contexts/AdminContext';
import { useAuthState } from '../../../../contexts/AuthContext';

import UserList from './UserList';
import UserDetails from './UserDetails';

const UserAdmin = () => {
	let { path } = useRouteMatch();

	const { user: { permissions } } = useAuthState();

	return (
		<AdminProvider>
			<Switch>
				{ log( 'user administration' ) }
				{ permissions.addUsers.isAvailable && permissions.addUsers.canExecute
					|| permissions.viewUsers.isAvailable && permissions.viewUsers.canExecute
					|| permissions.editUsers.isAvailable && permissions.editUsers.canExecute
					? <Route
						path={ `${ path }/:id` }
						component={ UserDetails }
					/>
					: null
				}
				<Route
					path={ path }
					component={ UserList }
				/>
			</Switch>
		</AdminProvider>
	);
};

export default memo( UserAdmin );
